import { useMemo } from 'react'
import { ethers } from 'ethers'
import { usePmWalletStore } from '@/store/pmWalletStore'

export function usePmSigner(): { signer: ethers.Signer; address: string; proxyAddress: string } | null {
  const pmPrivateKey = usePmWalletStore((s) => s.pmPrivateKey)
  const pmAddress = usePmWalletStore((s) => s.pmAddress)
  const pmProxyAddress = usePmWalletStore((s) => s.pmProxyAddress)

  return useMemo(() => {
    if (!pmPrivateKey || !pmAddress || !pmProxyAddress) return null
    const provider = new ethers.providers.JsonRpcProvider('https://polygon-bor-rpc.publicnode.com', 137)
    const wallet = new ethers.Wallet(pmPrivateKey, provider)
    return { signer: wallet, address: pmAddress, proxyAddress: pmProxyAddress }
  }, [pmPrivateKey, pmAddress, pmProxyAddress])
}
